import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthInState } from "./auth.type";

export const initialState: AuthInState = {
  token: localStorage.getItem("token"),
  role: localStorage.getItem("role") as "admin" | "user" | undefined,
  userId: localStorage.getItem("userId") || undefined,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")!)
    : undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setToken: (state, action: PayloadAction<Partial<typeof initialState>>) => {
      const { token, userId, user } = action.payload;

      if (token) {
        localStorage.setItem("token", token);
        state.token = token;
      }

      if (userId) {
        localStorage.setItem("userId", userId);
        state.userId = userId;
      }

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("role", user.role);
        state.user = user;
        state.role = user.role;
      }
    },
    setRole: (state, action: PayloadAction<Partial<typeof initialState>>) => {
      const role = action.payload.role;

      if (role) {
        localStorage.setItem("role", role);
        state.role = role;
      }
    },
    setUserId: (state, action: PayloadAction<Partial<typeof initialState>>) => {
      const userId = action.payload.userId;

      if (userId) {
        localStorage.setItem("userId", userId);
        state.userId = userId;
      }
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      localStorage.removeItem("user");
      state.token = null;
      state.role = undefined;
      state.userId = undefined;
      state.user = undefined;
    },
  },
});

export const { setToken, setRole, setUserId, logout } = authSlice.actions;

export const { reducer: authReducer } = authSlice;
